export default {
  'CHANGE_ADDRESSES' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'CLEAR_ADDRESSES' (state) {
    state.items = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/addresses/mutations.js